import { SITE } from '@/app/constants';

const CREATORS_GLOBAL_CONFIG = [
  [
    {
      id: 1,
      name: 'Grimsmile',
      order: 'grimsmile0095',
      quote:
        'Yes, Vidu has built entirely new model. Story Grid, first of its kind on the market. And it understands better than seedance because it has something that seedance never had and is not rigid as seedance model. Those tiny almost unnoticable details which no model currently on the market has implemented.',
      image: 'https://image01.cf.vidu.studio/vidu/media-asset/grimsmile-a49f7f2e.webp',
      xAccount: '',
    },
    {
      id: 2,
      name: 'Mamafish',
      order: 'mamafish',
      quote:
        "Who says AI creation isn't art? The beauty and art of using AI to create images lies within the mind of the artist and the ability of that artist to write a prompt that gets right the desired image in their mind. Saw a prompt somewhere online and had it saved in my notes. I decided to play around with it a little and make some adjustments. All made in Vidu's text-2-image area with GPT2.",
      image: 'https://image01.cf.vidu.studio/vidu/media-asset/mamafish-15c34031.webp',
      xAccount: '',
    },
  ],
  [
    {
      id: 3,
      name: 'Schmede',
      order: 'schmede1220',
      quote:
        "i'm in this civitai power user discord and we used to play this game with vidu q2ref when it first came out where we would all put in random images and throw them in with no prompt, tried that with story board got this one that was actually pretty nice",
      image: 'https://image01.cf.vidu.studio/vidu/media-asset/schmede-7a5bdc22.webp',
      xAccount: '',
    },
    {
      id: 4,
      name: 'Alper',
      order: 'atunc29',
      quote: 'i can see that the (viduclaw) outputs has been improve and also nice',
      image: 'https://image01.cf.vidu.studio/vidu/media-asset/alper-67037fae.webp',
      xAccount: '',
    },
  ],
  [
    {
      id: 5,
      name: '友憂',
      order: '',
      quote: '映像が綺麗だし元の画像から動画を生成しても顔とかの表現が崩れなくて最高で重宝してます',
      image: 'https://image01.cf.vidu.studio/vidu/media-asset/yy814283-1782bb9c.webp',
      xAccount: '',
    },
    {
      id: 6,
      name: '川崎賢二',
      order: '',
      quote: '機能性の充実と、コンテンツの豊富さなど、クリエイターのモチベーションが、上がる感じがするのがいいです。',
      image: 'https://image01.cf.vidu.studio/vidu/media-asset/ainokikara3517-1b2677ba.webp',
      xAccount: '',
    },
  ],
];

const CREATORS_CHINA_CONFIG = [
  [
    {
      id: 1,
      name: '冰皓',
      order: '@冰皓',
      quote:
        '创立多参宗，和成千上万 Vidu 玩家从 0 到 1，把 AI 视频玩出了花。这里有教程、有比赛、有战友，更有让创作者被看见的舞台。Vidu 陪我们走的这条路，不只是做视频，是让每个人都能用AI表达自己。',
      image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/binhao-372f6062.webp',
      xAccount: '',
    },
    {
      id: 2,
      name: 'Mashiro',
      order: '@Mashiro',
      quote:
        '我从小就想成为一名动画师。但要将我脑海中的创意转化为动画，需要很高的技能。然而，Vidu 的模型在动画方面比市场上大多数其他AI产品更为出色，能够让我实现梦想！它的运作速度非常快，使用起来也很简单！',
      image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/userImageChina3-97972b0d.webp',
      xAccount: '',
    },
  ],
  [
    {
      id: 3,
      name: 'Liguo',
      order: '@Liguo',
      quote:
        '我对 Vidu 的印象是：这是一家技术实力很突出的“小而强”公司。虽然公司规模不大，但功能做得很有特点。特别是多主体参考生视频功能，明显改善了AI 视频里的角色一致性问题，在角色表演、运镜和特效上都表现不错。',
      image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/zhouliguo-35fd2264.webp',
      xAccount: '',
    },
    {
      id: 4,
      name: '骆狮虎',
      order: '@骆狮虎',
      quote:
        'Vidu 是老牌的视频大模型了，从 Vidu 出来到如今都是极具性价比的一款模型，无论是图生、首尾、多参考等功能也涵盖了多功能的使用，而且一直在持续更新迭代，值得点赞！',
      image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/luoshihu-28216444.webp',
      xAccount: '',
    },
  ],
  [
    {
      id: 5,
      name: '玩 AI 的小笼包',
      order: '@玩 AI 的小笼包',
      quote:
        '我一直用 AI 做影视广告，也拿 Vidu 跑过不少商业项目。它最打动我的不只是快，而是真的懂镜头、动作和表演，让过去只能写在剧本里的画面，真正被做出来。',
      image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/xiaolongbao-120978a5.webp',
      xAccount: '',
    },
    {
      id: 6,
      name: '柔数特效',
      order: '@柔数特效',
      quote:
        'Vidu 第一次帮我解决的问题是，二次元人物动态有很好的流畅性，这个是当时很多AI平台不能控制的，我之前一直是使用 AE 为二次元人物做动态，Vidu 的出现让我在人物的编辑上节省了不少时间。',
      image: 'https://image01-aliyun.vidu.zone/vidu/media-asset/userImageChina4-5a2c61f5.webp',
      xAccount: '',
    },
  ],
];

export const CREATORS_CONFIG = SITE === 'china' ? CREATORS_CHINA_CONFIG : CREATORS_GLOBAL_CONFIG;
